import { useState } from "react";
import { SortingState } from "@tanstack/react-table";
import { TablePreviewResponse, TablePreviewVariant } from "~/components/table-preview/types";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const PAGE_SIZES: Record<TablePreviewVariant, number> = {
  [TablePreviewVariant.COMPACT]: 10,
  [TablePreviewVariant.FULL]: 25,
};

export function useTablePreview(tableFqn: string, variant: TablePreviewVariant) {
  const [pageIndex, setPageIndex] = useState(0);
  const [sortingState, setSortingStateRaw] = useState<SortingState>([]);
  const pageSize = PAGE_SIZES[variant];
  const offset = pageIndex * pageSize;

  const sortParam =
    sortingState.length > 0 ? `&sort=${sortingState[0].desc ? "-" : ""}${sortingState[0].id}` : "";

  const key = tableFqn
    ? `${VITE_CATALOG_API}/tables/fqn/${encodeURIComponent(tableFqn)}/query?offset=${offset}&limit=${pageSize}${sortParam}`
    : null;

  const { data, isLoading, error } = useFetcher<TablePreviewResponse>(key, {
    shouldCamelize: true,
    skipCamelizeKeys: ["items"],
  });

  function setSortingState(updater: SortingState | ((prev: SortingState) => SortingState)) {
    setPageIndex(0);
    setSortingStateRaw(updater);
  }

  return {
    data,
    isLoading,
    error,
    pageIndex,
    pageSize,
    setPageIndex,
    sortingState,
    setSortingState,
  };
}
